import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M17.9996 8.671L15.4136 6.085L16.4996 4.999L19.0856 7.585L17.9996 8.671ZM8.50661 18.164L5.27461 18.81L5.92061 15.578L13.9996 7.499L16.5856 10.085L8.50661 18.164ZM20.4996 6.171L17.9136 3.585C17.1346 2.805 15.8646 2.805 15.0856 3.585L4.29261 14.378C4.15261 14.518 4.05761 14.695 4.01961 14.889L3.01961 19.889C2.95361 20.217 3.05661 20.556 3.29261 20.792C3.48161 20.982 3.73661 21.085 3.99961 21.085C4.06461 21.085 4.13061 21.079 4.19561 21.066L9.19561 20.066C9.38961 20.027 9.56661 19.932 9.70661 19.792L20.4996 8.999C21.2796 8.219 21.2796 6.951 20.4996 6.171Z",
];

export function EditIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
